export default __webpack_public_path__ + "static/media/fp-dropdown.3d74f299.webp";